import { createAction, props } from '@ngrx/store';

/** User initiated logout – redirects to the external logout endpoint. */
export const logout = createAction('[Auth] Logout');

/**
 * Dispatched by the HTTP interceptor when a 401 is received after the session
 * has already been successfully bootstrapped (i.e. runtime session expiry).
 */
export const sessionExpired = createAction('[Auth] Session Expired');

/**
 * Dispatched when the user confirms the session-expired modal, triggering the
 * redirect to the external login page.
 */
export const sessionExpiredConfirmed = createAction('[Auth] Session Expired Confirmed');

export const addPasskey = createAction(
    '[Auth] Add Passkey'
);

export const addSocialLink = createAction(
    '[Auth] Add Social Link',
    props<{ provider: string }>()
);

export const removeSocialLink = createAction(
    '[Auth] Remove Social Link',
    props<{ provider: string }>()
);

export const removeSocialLinkConfirmed = createAction(
    '[Auth] Remove Social Link Confirmed',
    props<{ provider: string }>()
);

export const removeSocialLinkCancelled = createAction(
    '[Auth] Remove Social Link Cancelled'
);
